// Generated by Melange

import * as Caml_obj from "melange.js/caml_obj.js";
import * as Caml_option from "melange.js/caml_option.js";
import * as Lui_elements from "lui/lui_elements.js";
import * as Mapre_web__Web_model from "./web_model.js";
import * as Mapre_web__Web_permissions_model from "./web_permissions_model.js";
import * as Signal from "ocaml-signal/signal.js";
import * as Stdlib__Int from "melange/int.js";
import * as Stdlib__List from "melange/list.js";
import * as Stdlib__Option from "melange/option.js";
import * as Stdlib__String from "melange/string.js";

function available(row) {
  if (row.allowed && Caml_obj.caml_equal(row.item.decision, /* Pending */ 0)) {
    return row.attempt === undefined;
  } else {
    return false;
  }
}

function choices(source, send, seq) {
  const partial_arg = Signal.map((function (r) {
    return r.item.options;
  }), source);
  const partial_arg$1 = {
    TAG: /* Permissions */ 42,
    _0: {
      TAG: /* Choose */ 0,
      _0: seq,
      _1: undefined
    }
  };
  const partial_arg$2 = (function (param) {
    return Lui_elements.press(send, partial_arg$1, param);
  });
  const partial_arg$3 = "ghost";
  const partial_arg$4 = "Cancel request";
  const partial_arg_0 = function (param, param$1) {
    return Lui_elements.keyed(partial_arg, (function (c) {
      return c.id;
    }), Stdlib__String.compare, (function (choice) {
      const id = Signal.sample(choice).id;
      return function (param, param$1) {
        return Lui_elements.scoped((function (__lui_context___001_) {
          const partial_arg = {
            TAG: /* Permissions */ 42,
            _0: {
              TAG: /* Choose */ 0,
              _0: seq,
              _1: id
            }
          };
          const partial_arg$1 = (function (param) {
            return Lui_elements.press(send, partial_arg, param);
          });
          const partial_arg$2 = "outline";
          const partial_arg$3 = Caml_option.some(Signal.own_signal(__lui_context___001_.ui_scope, Signal.map((function (c) {
            return c.name;
          }), choice)));
          return function (param, param$1) {
            return Lui_elements.button(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$3, partial_arg$2, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$1, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
          };
        }), param, param$1);
      };
    }), param, param$1);
  };
  const partial_arg_1 = {
    hd: (function (param, param$1) {
      return Lui_elements.button(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$4, undefined, partial_arg$3, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$2, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
    }),
    tl: /* [] */ 0
  };
  const partial_arg$5 = {
    hd: partial_arg_0,
    tl: partial_arg_1
  };
  const partial_arg$6 = 8;
  return function (param, param$1) {
    return Lui_elements.column(undefined, partial_arg$6, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$5, param, param$1);
  };
}

function confirmation(source, send) {
  const partial_arg = "This choice can apply beyond this command. Review the scope above before confirming.";
  const partial_arg$1 = "muted";
  const partial_arg$2 = {
    TAG: /* Permissions */ 42,
    _0: /* Confirm */ 0
  };
  const partial_arg$3 = (function (param) {
    return Lui_elements.press(send, partial_arg$2, param);
  });
  const partial_arg$4 = "primary";
  const partial_arg$5 = "Confirm decision";
  const partial_arg$6 = {
    TAG: /* Permissions */ 42,
    _0: /* Keep_reviewing */ 1
  };
  const partial_arg$7 = (function (param) {
    return Lui_elements.press(send, partial_arg$6, param);
  });
  const partial_arg$8 = "outline";
  const partial_arg$9 = "Keep reviewing";
  const partial_arg_0 = function (param, param$1) {
    return Lui_elements.button(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$5, undefined, partial_arg$4, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$3, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
  };
  const partial_arg_1 = {
    hd: (function (param, param$1) {
      return Lui_elements.button(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$9, undefined, partial_arg$8, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$7, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
    }),
    tl: /* [] */ 0
  };
  const partial_arg$10 = {
    hd: partial_arg_0,
    tl: partial_arg_1
  };
  const partial_arg$11 = "wrap";
  const partial_arg$12 = 8;
  const partial_arg_0$1 = function (param, param$1) {
    return Lui_elements.scoped((function (__lui_context___002_) {
      const partial_arg = Caml_option.some(Signal.own_signal(__lui_context___002_.ui_scope, Signal.map((function (r) {
        const choice = Stdlib__List.find_opt((function (c) {
          return Caml_obj.caml_equal(c.id, r.confirmation);
        }), r.item.options);
        return "Confirm persistent decision: " + Stdlib__Option.fold("", (function (c) {
          return c.name;
        }), choice);
      }), source)));
      const partial_arg$1 = "notice";
      return function (param, param$1) {
        return Lui_elements.text(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$1, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
      };
    }), param, param$1);
  };
  const partial_arg_1$1 = {
    hd: (function (param, param$1) {
      return Lui_elements.text(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$1, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
    }),
    tl: {
      hd: (function (param, param$1) {
        return Lui_elements.row(undefined, partial_arg$12, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$11, undefined, partial_arg$10, param, param$1);
      }),
      tl: /* [] */ 0
    }
  };
  const partial_arg$13 = {
    hd: partial_arg_0$1,
    tl: partial_arg_1$1
  };
  const partial_arg$14 = 8;
  return function (param, param$1) {
    return Lui_elements.column(undefined, partial_arg$14, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$13, param, param$1);
  };
}

function view(source, send) {
  const rows = Signal.map((function (m) {
    return Stdlib__List.map((function (item) {
      return {
        item,
        attempt: Mapre_web__Web_permissions_model.attempt(m.permissions, item.seq),
        confirmation: Stdlib__Option.bind(m.permissions.confirmation, (function (param) {
          if (item.seq === param[0]) {
            return param[1];
          }
          
        })),
        allowed: Mapre_web__Web_model.can_create(m) && !Mapre_web__Web_model.locked(m) && !m.permissions.denied
      };
    }), m.permissions.items);
  }), source);
  const partial_arg = "Agent permissions";
  const partial_arg$1 = 2;
  const partial_arg$2 = {
    TAG: /* Permissions */ 42,
    _0: /* Refresh */ 2
  };
  const partial_arg$3 = (function (param) {
    return Lui_elements.press(send, partial_arg$2, param);
  });
  const partial_arg$4 = "outline";
  const partial_arg$5 = "Refresh permissions";
  const partial_arg_0 = function (param, param$1) {
    return Lui_elements.heading(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$1, partial_arg, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
  };
  const partial_arg_1 = {
    hd: (function (param, param$1) {
      return Lui_elements.button(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$5, undefined, partial_arg$4, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$3, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
    }),
    tl: /* [] */ 0
  };
  const partial_arg$6 = {
    hd: partial_arg_0,
    tl: partial_arg_1
  };
  const partial_arg$7 = "wrap";
  const partial_arg$8 = 8;
  const partial_arg$9 = function (param, param$1) {
    return Lui_elements.row(undefined, partial_arg$8, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$7, undefined, partial_arg$6, param, param$1);
  };
  const partial_arg$10 = Signal.map((function (m) {
    if (Caml_obj.caml_notequal(m.permissions.items, /* [] */ 0)) {
      return true;
    } else {
      return m.permissions.message !== "";
    }
  }), source);
  const partial_arg$11 = Signal.map((function (m) {
    return m.permissions.message !== "";
  }), source);
  const partial_arg_0$1 = function (param, param$1) {
    return Lui_elements.if_(partial_arg$10, partial_arg$9, param, param$1);
  };
  const partial_arg_1$1 = {
    hd: (function (param, param$1) {
      return Lui_elements.if_(partial_arg$11, (function (param, param$1) {
        return Lui_elements.scoped((function (__lui_context___007_) {
          const partial_arg = Caml_option.some(Signal.own_signal(__lui_context___007_.ui_scope, Signal.map((function (m) {
            return m.permissions.message;
          }), source)));
          const partial_arg$1 = "notice";
          return function (param, param$1) {
            return Lui_elements.text(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$1, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
          };
        }), param, param$1);
      }), param, param$1);
    }),
    tl: {
      hd: (function (param, param$1) {
        return Lui_elements.keyed(rows, (function (r) {
          return r.item.seq;
        }), Stdlib__Int.compare, (function (param) {
          const seq = Signal.sample(param).item.seq;
          const partial_arg = choices(param, send, seq);
          const partial_arg$1 = Signal.map((function (r) {
            if (available(r)) {
              return r.confirmation === undefined;
            } else {
              return false;
            }
          }), param);
          const partial_arg$2 = confirmation(param, send);
          const partial_arg$3 = Signal.map((function (r) {
            if (available(r)) {
              return r.confirmation !== undefined;
            } else {
              return false;
            }
          }), param);
          const partial_arg$4 = "Only members with execution permission can reply.";
          const partial_arg$5 = "muted";
          const partial_arg$6 = function (param, param$1) {
            return Lui_elements.text(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$5, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$4, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
          };
          const partial_arg$7 = Signal.map((function (r) {
            if (Caml_obj.caml_equal(r.item.decision, /* Pending */ 0)) {
              return !r.allowed;
            } else {
              return false;
            }
          }), param);
          const partial_arg$8 = {
            TAG: /* Permissions */ 42,
            _0: {
              TAG: /* Retry */ 1,
              _0: seq
            }
          };
          const partial_arg$9 = (function (param) {
            return Lui_elements.press(send, partial_arg$8, param);
          });
          const partial_arg$10 = "outline";
          const partial_arg$11 = "Retry same reply";
          const partial_arg$12 = function (param, param$1) {
            return Lui_elements.button(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$11, undefined, partial_arg$10, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$9, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
          };
          const partial_arg$13 = Signal.map((function (r) {
            if (r.allowed) {
              return Stdlib__Option.fold(false, (function (a) {
                return a.phase === /* Uncertain */ 1;
              }), r.attempt);
            } else {
              return false;
            }
          }), param);
          const partial_arg_0 = function (param$1, param$2) {
            return Lui_elements.scoped((function (__lui_context___006_) {
              const partial_arg = Caml_option.some(Signal.own_signal(__lui_context___006_.ui_scope, Signal.map((function (r) {
                const match = r.attempt;
                if (match === undefined) {
                  return "Reply delivery is uncertain. Refresh or retry the same decision.";
                }
                switch (match.phase) {
                  case /* Sending */ 0 :
                    return "Sending decision...";
                  case /* Uncertain */ 1 :
                    return "Reply delivery is uncertain. Refresh or retry the same decision.";
                  case /* Accepted */ 2 :
                    return "Reply accepted. Refreshing decision...";
                }
              }), param)));
              const partial_arg$1 = "muted";
              return function (param, param$1) {
                return Lui_elements.text(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$1, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
              };
            }), param$1, param$2);
          };
          const partial_arg_1 = {
            hd: (function (param, param$1) {
              return Lui_elements.if_(partial_arg$13, partial_arg$12, param, param$1);
            }),
            tl: /* [] */ 0
          };
          const partial_arg$14 = {
            hd: partial_arg_0,
            tl: partial_arg_1
          };
          const partial_arg$15 = 8;
          const partial_arg$16 = function (param, param$1) {
            return Lui_elements.column(undefined, partial_arg$15, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$14, param, param$1);
          };
          const partial_arg$17 = Signal.map((function (r) {
            return r.attempt !== undefined;
          }), param);
          const partial_arg_0$1 = function (param$1, param$2) {
            return Lui_elements.scoped((function (__lui_context___003_) {
              const partial_arg = Caml_option.some(Signal.own_signal(__lui_context___003_.ui_scope, Signal.map((function (r) {
                return r.item.title;
              }), param)));
              const partial_arg$1 = 3;
              return function (param, param$1) {
                return Lui_elements.heading(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$1, undefined, partial_arg, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
              };
            }), param$1, param$2);
          };
          const partial_arg_1$1 = {
            hd: (function (param$1, param$2) {
              return Lui_elements.scoped((function (__lui_context___004_) {
                const partial_arg = Caml_option.some(Signal.own_signal(__lui_context___004_.ui_scope, Signal.map((function (r) {
                  return r.item.detail;
                }), param)));
                const partial_arg$1 = "event-text permission-command";
                return function (param, param$1) {
                  return Lui_elements.text(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$1, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
                };
              }), param$1, param$2);
            }),
            tl: {
              hd: (function (param$1, param$2) {
                return Lui_elements.scoped((function (__lui_context___005_) {
                  const partial_arg = Caml_option.some(Signal.own_signal(__lui_context___005_.ui_scope, Signal.map((function (r) {
                    return Mapre_web__Web_permissions_model.decision_text(r.item);
                  }), param)));
                  const partial_arg$1 = "muted";
                  return function (param, param$1) {
                    return Lui_elements.text(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$1, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
                  };
                }), param$1, param$2);
              }),
              tl: {
                hd: (function (param, param$1) {
                  return Lui_elements.if_(partial_arg$1, partial_arg, param, param$1);
                }),
                tl: {
                  hd: (function (param, param$1) {
                    return Lui_elements.if_(partial_arg$3, partial_arg$2, param, param$1);
                  }),
                  tl: {
                    hd: (function (param, param$1) {
                      return Lui_elements.if_(partial_arg$7, partial_arg$6, param, param$1);
                    }),
                    tl: {
                      hd: (function (param, param$1) {
                        return Lui_elements.if_(partial_arg$17, partial_arg$16, param, param$1);
                      }),
                      tl: /* [] */ 0
                    }
                  }
                }
              }
            }
          };
          const partial_arg$18 = {
            hd: partial_arg_0$1,
            tl: partial_arg_1$1
          };
          const partial_arg$19 = {
            hd: [
              "data-permission-seq",
              String(seq)
            ],
            tl: /* [] */ 0
          };
          const partial_arg$20 = "command-card";
          const partial_arg$21 = 0;
          const partial_arg$22 = 16;
          const partial_arg$23 = 10;
          return function (param, param$1) {
            return Lui_elements.column(undefined, partial_arg$23, undefined, undefined, undefined, undefined, undefined, partial_arg$22, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$21, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$20, partial_arg$19, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$18, param, param$1);
          };
        }), param, param$1);
      }),
      tl: /* [] */ 0
    }
  };
  const partial_arg$12 = {
    hd: partial_arg_0$1,
    tl: partial_arg_1$1
  };
  const partial_arg$13 = 0;
  const partial_arg$14 = 12;
  return function (param, param$1) {
    return Lui_elements.column(undefined, partial_arg$14, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$13, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$12, param, param$1);
  };
}

export {
  view,
}
/* Lui_elements Not a pure module */
